export default "__VITE_ASSET__CFqgLjNR__"